// extracted by mini-css-extract-plugin
export default {"button":"vFhB6y","primary":"vOHxES","disabled":"KxJ2yi","secondary":"IR7Ccs","dangerText":"yXzLRL","swap":"mU0qI3","text":"elUm1F"};